import axios from 'axios'
import typia from 'typia'

import { storeConfig } from '@/locale'
import { isObject } from '@/utils/type.util'

import { sentry } from './sentry'

/**
 *
 * @param handle Design deconstruction handle
 */
export async function getPromoteMessagesByProduct(handle: string): Promise<string[]> {
  const promoteMessages = await getPromoteMessages()

  if (promoteMessages === null) {
    return []
  }

  const outputMessages: string[] = []
  for (const msg of promoteMessages) {
    if (
      msg.product_line_lists.some(
        // Ignore -featured-product suffix
        // which are appended by strapi server.
        (item) => item.handle.replace(/-featured-product$/, '') === handle,
      )
    ) {
      outputMessages.push(msg.content)
    }
  }
  return outputMessages
}

let cachedMessages: null | PromoteMessage[] = null
async function getPromoteMessages(): Promise<null | PromoteMessage[]> {
  if (cachedMessages !== null) {
    return cachedMessages
  }
  const url = `https://cms.rhinoshield.app/custom-api/product-buying-promo-messages?locale=${storeConfig.language}&env=live`
  try {
    const result = await axios.get(url)
    if (!isObject(result.data) || !('data' in result.data)) {
      throw Error()
    }
    const data = result.data['data']
    cachedMessages = typia.is<PromoteMessage[]>(data) ? data : null
  } catch (error) {
    sentry.error('Fail getting promote message', {
      error,
      url,
      locale: storeConfig.language,
    })
  }
  return cachedMessages
}

/**
 * Ignore
 * id: number
 * identification: string
 * name: string
 * Because we are not using them
 */
interface FeatureProduct {
  handle: string
}

interface PromoteMessage {
  content: string
  id: number
  // eslint-disable-next-line @typescript-eslint/naming-convention
  product_line_lists: FeatureProduct[]
}
